import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteMachine } from "../../api/machine";
import Machine from "../../models/machine";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface MachineDeleteModalProps {
  show: boolean;
  machine?: Machine;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const MachineDeleteModal: React.FC<MachineDeleteModalProps> = ({
  show,
  machine,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = machine
    ? `Está seguro de que quiere eliminar la máquina ${machine.name}`
    : "";

  const onDeleteClick = async () => {
    if (machine !== undefined) {
      setSubmitting(true);
      const machineStatus = await deleteMachine(machine);

      if (machineStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (machineStatus.detail !== undefined) {
          message = machineStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default MachineDeleteModal;
